export default __webpack_public_path__ + "static/lefafa_3_1-2c5459bdbc09614989288d8fe04e923f.webp";